import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./UserGroups'),
  (m) => m.default
);
